import { Component } from '@angular/core';
import { IzzyAssignmentRuleEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Assignment Rules') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzyassignmentrule-form',
    templateUrl: './izzyassignmentrule.form.component.html'
})
export class IzzyAssignmentRuleFormComponent extends BaseFormComponent {
    public record!: IzzyAssignmentRuleEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'ruleConfiguration', sectionName: 'Rule Configuration', isExpanded: true },
            { sectionKey: 'ruleLogic', sectionName: 'Rule Logic', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

